class NotifyMeForm extends HTMLElement {
  connectedCallback() {
    this.companyId = this.dataset.klaviyoCompanyId;
    this.productId = this.dataset.productId;
    this.variantId = this.dataset.variantId;
    this.productName = this.dataset.productName;
    this.variantTitle = this.dataset.variantTitle;
    this.productUrl = this.dataset.productUrl;
    this.imageUrl = this.dataset.imageUrl;
    this.sku = this.dataset.sku;
    this.price = this.dataset.price;
    this.form = this.querySelector('form');
    this.successEl = this.querySelector('[data-notify-me-success]');
    this.errorEl = this.querySelector('[data-notify-me-error]');
    this.submitBtn = this.querySelector('button[type="submit"]');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    if (!this.companyId) return this.showError('Notification service not configured.');

    const emailInput = this.form.querySelector('input[type="email"]');
    const email = (emailInput?.value || '').trim();
    if (!email || !this.isValidEmail(email)) return this.showError('Please enter a valid email address.');
    if (!this.variantId) return this.showError('Could not identify product variant.');

    this.clearError();
    this.setSubmitting(true);

    try {
      // Custom event first — triggers confirmation flow with full product context
      await this.postCustomEvent(email);
      // Native subscription second — required for the restock alert flow
      const subscribed = await this.postBackInStockSubscription(email);
      if (subscribed) this.showSuccess();
      else this.setSubmitting(false);
    } catch (err) {
      this.showError('Network error. Please try again.');
      this.setSubmitting(false);
    }
  }

  async postCustomEvent(email) {
    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(this.companyId)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15', 'Accept': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Form Submitted' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } },
                properties: {
                  ProductID: this.productId,
                  VariantID: this.variantId,
                  ProductName: this.productName,
                  VariantName: this.variantTitle,
                  ProductURL: this.productUrl,
                  ImageURL: this.imageUrl,
                  SKU: this.sku || '',
                  Price: this.price || '',
                },
              },
            },
          }),
        }
      );
      return response.status === 202 || response.ok;
    } catch (err) {
      return false;
    }
  }

  async postBackInStockSubscription(email) {
    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15', 'Accept': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } },
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variantId}` } },
            },
          },
        }),
      }
    );
    if (response.status === 202 || response.ok) return true;
    const body = await response.json().catch(() => null);
    const detail = body?.errors?.[0]?.detail || 'Something went wrong. Please try again.';
    this.showError(detail);
    return false;
  }

  isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }
  setSubmitting(isSubmitting) { if (this.submitBtn) this.submitBtn.disabled = isSubmitting; }
  showSuccess() { if (this.form) this.form.hidden = true; if (this.successEl) { this.successEl.hidden = false; this.successEl.setAttribute('aria-live', 'polite'); } }
  showError(message) { if (!this.errorEl) return; this.errorEl.textContent = message; this.errorEl.hidden = false; }
  clearError() { if (!this.errorEl) return; this.errorEl.textContent = ''; this.errorEl.hidden = true; }
}

if (!customElements.get('back-in-stock-form')) {
  customElements.define('back-in-stock-form', NotifyMeForm);
}
